import { Outlet, useLocation } from 'react-router-dom';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';
import { SkipLink } from '@components/a11y/SkipLink';
import { ScreenReaderAnnouncements } from '@components/a11y/ScreenReaderAnnouncements';

export default function Layout() {
  const location = useLocation();
  const shouldReduceMotion = useReducedMotion();

  return (
    <>
      {/* Skip to main content link for keyboard users */}
      <SkipLink targetId="main-content" />
      
      {/* Screen reader announcements for dynamic content */}
      <ScreenReaderAnnouncements />
      
      <div className="min-h-screen flex flex-col bg-slate-950">
        <Header />
        
        {/* Main content landmark with ID for skip link */}
        <main 
          id="main-content"
          className="flex-1"
          tabIndex={-1} /* Allows programmatic focus but excludes from tab order */
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={shouldReduceMotion ? {} : { opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={shouldReduceMotion ? {} : { opacity: 0, y: -20 }}
              transition={{ 
                duration: shouldReduceMotion ? 0 : 0.3, 
                ease: [0.25, 0.1, 0.25, 1] 
              }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
        
        <Footer />
      </div>
    </>
  );
}
